export default "__VITE_ASSET__c392f51c__"